/**
 * iPhone, iPad and Mac let apps — WhatsApp, and the notification that brings its
 * code — use a Wi-Fi only once it has passed their own online check, and in the
 * sign-in window they check again only when it loads a page. So with the branch's
 * internet before sign-in open (the server tells these devices only — backend
 * portal.controller getLandingPage) the page loads once more, the device checks,
 * sees the Wi-Fi work, and the code can come without mobile data.
 */

const APPLE_RE = /iPhone|iPad|iPod|Macintosh/; // an iPad's Safari says Macintosh
export const PRELOGIN_RELOADED_KEY = 'hotwifi.preLoginReloaded';

export const isAppleDevice = (ua = window.navigator.userAgent) => APPLE_RE.test(ua || '');

/**
 * Loads the page once more (true) — or not (false): not an Apple device, already
 * done on this page, or no storage to remember it by (better none than a loop).
 */
export function reloadForOnlineCheck(reload = () => window.location.reload()) {
    if (!isAppleDevice()) return false;
    try {
        if (window.sessionStorage.getItem(PRELOGIN_RELOADED_KEY)) return false;
        window.sessionStorage.setItem(PRELOGIN_RELOADED_KEY, '1');
    } catch {
        return false;
    }
    reload();
    return true;
}
